/**
 * E-freight warehouse location (hardcoded).
 * Used for "Containervervoer plaats van bestemming" when delivery type is storage.
 * Lindeboomseweg 57, 3825 AL Amersfoort, Netherlands
 */
export const WAREHOUSE_COORDINATES = {
  lat: 52.1987397,
  lon: 5.3986348,
} as const;
